import { ReportSection } from './schemas';

export const vendorReportKeys = {
  all: ['vendor-reports'] as const,
  detail: (id: string) => [...vendorReportKeys.all, 'detail', id] as const,
  shareLink: (id: string, sections: ReportSection[]) =>
    [...vendorReportKeys.detail(id), 'shareLink', { sections }] as const
};
